import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'
import useReturnPortalFeatures from '@/common/hooks/useReturnPortalFeatures/useReturnPortalFeatures'

import useOpenParcelDetail from './hooks/useOpenParcelDetail/useOpenParcelDetail'
import ParcelCard from './ParcelCard/ParcelCard'
import { getParcelDetailRoute } from './helpers'
import * as Styles from './styles'

const ParcelsSection = ({ parcels, storeId, orderTrackingPageUrl }) => {
  const { t } = useTranslation()
  const { info } = useContext(AppContext)
  const { returnPortalFeatures } = useReturnPortalFeatures({ returnPortalId: info?.selectedReturnPortal?.id })
  const { handleOpenParcelDetail } = useOpenParcelDetail({ storeId })

  return (
    <Styles.Container>
      <Text type="titleS">{t('Envíos')}</Text>
      <Styles.List>
        {parcels.map(parcel => (
          <ParcelCard
            key={parcel.id}
            parcel={parcel}
            onViewParcelDetail={() => handleOpenParcelDetail(getParcelDetailRoute(parcel.id))}
            orderTrackingPageUrl={orderTrackingPageUrl}
            displayCarrierTrackingPageAction={returnPortalFeatures?.display_carrier_tracking_page_action}
          />
        ))}
      </Styles.List>
    </Styles.Container>
  )
}

export default ParcelsSection
